import React from "react";
import PublicNav from "@/components/PublicNav";
import PublicFooter from "@/components/PublicFooter";
import Section from "@/components/Section";
import CinematicShell from "@/components/cinematic/CinematicShell";
import { CompanyParadeStill } from "@/components/cinematic/stills";

export default function CompanyPage() {
  return (
    <>
      <PublicNav />
      <div className="relative dt6-cinematic-vignette" style={{ minHeight: "440px" }}>
        <CinematicShell
          sceneImport={() => import("@/components/cinematic/scenes/CompanyParade")}
          stillSrc={CompanyParadeStill}
          testId="company-hero-scene"
          className="dt6-cinematic-grain"
          style={{ position: "absolute", inset: 0, zIndex: 0 }}
        />
        <Section className="pt-16 pb-8 relative dt6-cinematic-copy" testId="company-hero">
          <div className="dt6-chip dt6-chip-primary mb-4">/ COMPANY</div>
          <h1 className="font-heading text-5xl md:text-6xl font-black leading-tight max-w-4xl">
            Data infrastructure for the <span style={{ color: "var(--dt6-primary)" }}>right side</span> of the fight.
          </h1>
        </Section>
      </div>

      <Section className="py-8" testId="company-mission">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="dt6-card p-8" style={{ borderColor: "var(--dt6-primary)" }} data-testid="company-declaration">
            <div className="dt6-chip dt6-chip-primary mb-3">/ THE DECLARATION</div>
            <p className="text-[color:var(--dt6-text)] leading-relaxed">
              DT6 arms America First leaders and organizations. No exceptions, no dual loyalties, no strategic neutrality. If your mission does not put the American citizen first, our stack is not for sale to you at any price.
            </p>
          </div>
          <div className="dt6-card p-8">
            <div className="dt6-chip mb-3">/ DOCTRINE</div>
            <p className="text-[color:var(--dt6-text)]">
              Six modules. One stack. Every deliverable auditable. Every hand-off logged. No vaporware, no vendor lock-in, no compliance theater.
            </p>
          </div>
        </div>
      </Section>

      <Section className="py-8" testId="company-partners-note">
        <div className="dt6-card p-8">
          <div className="dt6-chip mb-3">/ FLAGSHIP CHANNEL PARTNERS</div>
          <p className="text-[color:var(--dt6-muted)]">
            DT6 works with established consultants and agencies who want to deliver the six-module stack under their brand. See <a href="/partners" className="dt6-link">/partners</a> for the program mechanics.
          </p>
        </div>
      </Section>

      <Section className="py-8 pb-16" testId="company-leadership">
        <div className="dt6-chip mb-3">/ LEADERSHIP</div>
        <div className="dt6-empty" data-testid="leadership-empty">
          LEADERSHIP BIOS PENDING. HANDLES DISCLOSED UNDER NDA.
        </div>
      </Section>

      <PublicFooter />
    </>
  );
}
